import { Grid } from '@material-ui/core'
import React, { FunctionComponent } from 'react'
import {
  MdPictureInPictureAlt,
  MdKeyboardArrowRight,
  MdPermIdentity,
} from 'react-icons/md'
import { useHistory } from 'react-router'
import { formatBreadCrumb } from 'shared/components/BasePage/formatBreadCrumb'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'

import { BreadCrumb, Card, ContainerCards, Content, Title } from './styles'
import { useAuth } from 'modules/auth/hooks/auth'

const GerenciarConta: FunctionComponent = () => {
  const history = useHistory()
  const handleClickGerenciarConta = () => {
    history.push('/cnpjs-vinculados')
  }

  const handleClickGerenciarUsuarios = () => {
    history.push('/usuarios-vinculados')
  }

  const { user } = useAuth()

  if (user && user !== 'suporte.ti@tmov.com.br') {
    history.push('/')
  }

  return (
    <Content>
      <BreadCrumb>
        <Title>{formatBreadCrumb('Home / Gerenciar Conta')}</Title>
      </BreadCrumb>
      <ContainerCards>
        <Grid container spacing={6}>
          <Grid item md={4}>
            <Card onClick={handleClickGerenciarConta}>
              <Grid container justifyContent="flex-end" spacing={3}>
                <Grid item md={2}>
                  <MdPictureInPictureAlt color={colors.blue} />
                </Grid>
                <Grid item md={8}>
                  <Text color={colors.green} style={{ fontWeight: 'bold' }}>
                    CNPJs vinculados
                  </Text>
                </Grid>
                <Grid item md={2}>
                  <MdKeyboardArrowRight color={colors.green} />
                </Grid>
              </Grid>
              <Text style={{ marginTop: 10 }}>
                Acesse, edite e adicione novos CNPJs em sua conta
              </Text>
            </Card>
          </Grid>
          <Grid item md={4}>
            <Card onClick={handleClickGerenciarUsuarios}>
              <Grid container justifyContent="flex-end" spacing={3}>
                <Grid item md={2}>
                  <MdPermIdentity color={colors.blue} />
                </Grid>
                <Grid item md={8}>
                  <Text color={colors.green} style={{ fontWeight: 'bold' }}>
                    Usuários
                  </Text>
                </Grid>
                <Grid item md={2}>
                  <MdKeyboardArrowRight color={colors.green} />
                </Grid>
              </Grid>
              <Text style={{ marginTop: 10 }}>
                Gerencie e adicione novos usuários na plataforma
              </Text>
            </Card>
          </Grid>
        </Grid>
      </ContainerCards>
    </Content>
  )
}

export default GerenciarConta
